import React, { ReactElement, useEffect, useCallback, useState } from 'react';
import { Error, NotFound, Icon } from '@shootsta/common-react';

import ShareablePage from './ShareablePage';
import SplashPage from './SplashPage';

import { Contents, GraphqlResponse } from '../types';

interface SplashPageProps {
  getSplashPage: () => Promise<GraphqlResponse>;
  splashPageId: string;
}

interface SplashDetailsState {
  isLoading: boolean;
  data: unknown | undefined;
  error: Error | null
}

const SplashNavigator = (props: SplashPageProps): ReactElement | null => {
  const { getSplashPage, splashPageId } = props;

  const [splashDetails, setSplashDetails] = useState<SplashDetailsState>({
    isLoading: false,
    data: void 0,
    error: null
  });

  const fetchSplashData = useCallback(async () => {
    setSplashDetails((state: SplashDetailsState) => ({ ...state, isLoading: true }));
    const { data, error } = await getSplashPage();

    if (!error) {
      setSplashDetails((state: SplashDetailsState) => ({ ...state, data: data?.getShareablePage }));
    } else {
      setSplashDetails((state: SplashDetailsState) => ({ ...state, error }));
    }

    setSplashDetails((state: SplashDetailsState) => ({ ...state, isLoading: false }));
  }, [getSplashPage, setSplashDetails]);

  useEffect(() => {
    fetchSplashData();
  }, [fetchSplashData]);

  if (splashDetails.error) {
    return <Error />;
  }

  if (splashDetails.data === null) {
    return <NotFound />;
  }

  if (splashDetails.isLoading || !splashDetails.data) {
    return (
      <main style={{ justifyContent: 'center' }}>
        <Icon name="shootstagrad" size={40} color="black" spin />
      </main>
    );
  }

  const contents: Contents = (splashDetails.data as { contents: Contents })?.contents;

  return (
    <>
      {contents ? <SplashPage id={splashPageId} /> : <ShareablePage id={splashPageId} />}
    </>
  );
};

export default SplashNavigator;
